module.exports = __webpack_public_path__ + "546c705dd8304e566e7e9b424a466b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/img1_2.jpg
// module id = 460
// module chunks = 0